"use strict";

var _defineProperty = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));

var prosemirror_view_1 = require("prosemirror-view");

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var prosemirror_commands_1 = require("prosemirror-commands");

var backspaceToParagraph_1 = __importDefault(require("../commands/backspaceToParagraph"));

var toggleBlockType_1 = __importDefault(require("../commands/toggleBlockType"));

var headingToSlug_1 = __importDefault(require("../lib/headingToSlug"));

var Node_1 = __importDefault(require("./Node"));

var types_1 = require("../types");

var Heading = /*#__PURE__*/function (_Node_1$default) {
  _inherits(Heading, _Node_1$default);

  var _super = _createSuper(Heading);

  function Heading() {
    var _this;

    _classCallCheck(this, Heading);

    _this = _super.apply(this, arguments);
    _this.className = "heading-name";

    _this.handleCopyLink = function () {
      return function (event) {
        var anchor = event.currentTarget.nextSibling.getElementsByClassName(_this.className)[0];
        var hash = "#".concat(anchor.id);
        var urlWithoutHash = window.location.href.split("#")[0];
        copy_to_clipboard_1.default(urlWithoutHash + hash);

        if (_this.options.onShowToast) {
          _this.options.onShowToast(_this.options.dictionary.linkCopied, types_1.ToastType.Info);
        }
      };
    };

    return _this;
  }

  _createClass(Heading, [{
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.write(state.repeat("#", node.attrs.level) + " ");
      state.renderInline(node);
      state.closeBlock(node);
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "heading",
        getAttrs: function getAttrs(token) {
          return {
            level: +token.tag.slice(1)
          };
        }
      };
    }
  }, {
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return function (attrs) {
        return toggleBlockType_1.default(type, schema.nodes.paragraph, attrs);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type;
      var options = this.options.levels.reduce(function (items, level) {
        return Object.assign(Object.assign({}, items), _defineProperty({}, "Shift-Ctrl-".concat(level), prosemirror_commands_1.setBlockType(type, {
          level: level
        })));
      }, {});
      return Object.assign(Object.assign({}, options), {
        Backspace: backspaceToParagraph_1.default(type)
      });
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return this.options.levels.map(function (level) {
        return prosemirror_inputrules_1.textblockTypeInputRule(new RegExp("^(#{1,".concat(level, "})\\s$")), type, function () {
          return {
            level: level
          };
        });
      });
    }
  }, {
    key: "name",
    get: function get() {
      return "heading";
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {
        levels: [1, 2, 3, 4]
      };
    }
  }, {
    key: "schema",
    get: function get() {
      var _this2 = this;

      return {
        attrs: {
          level: {
            default: 1
          }
        },
        content: "inline*",
        group: "block",
        defining: true,
        draggable: false,
        parseDOM: this.options.levels.map(function (level) {
          return {
            tag: "h".concat(level),
            attrs: {
              level: level
            }
          };
        }),
        toDOM: function toDOM(node) {
          var button = document.createElement("button");
          button.innerText = "#";
          button.type = "button";
          button.className = "heading-anchor";
          button.addEventListener("click", _this2.handleCopyLink());
          return ["h".concat(node.attrs.level + (_this2.options.offset || 0)), button, ["span", 0]];
        }
      };
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this3 = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          decorations: function decorations(state) {
            var doc = state.doc;
            var decorations = [];
            var previouslySeen = {};
            doc.descendants(function (node, pos) {
              if (node.type.name !== _this3.name) return;
              var slug = headingToSlug_1.default(node);
              var id = slug;

              if (previouslySeen[slug] > 0) {
                id = headingToSlug_1.default(node, previouslySeen[slug]);
              }

              previouslySeen[slug] = previouslySeen[slug] !== undefined ? previouslySeen[slug] + 1 : 1;
              decorations.push(prosemirror_view_1.Decoration.inline(pos, pos + node.nodeSize, {
                id: id,
                class: _this3.className,
                nodeName: "a"
              }));
            });
            return prosemirror_view_1.DecorationSet.create(doc, decorations);
          }
        }
      })];
    }
  }]);

  return Heading;
}(Node_1.default);

exports.default = Heading;